import { FsPresenceDevice } from './presence-device';

export class FsPresenceResponse {
  features: FsPresenceDevice[];
  type: string;
  nextURL: string;
}
